import { GridIcon, ListIcon } from "../../../../assets/svgIcons";
import { useGetPricingTypes } from "../../../../hooks/api/queries";
import { useSellModeFilters } from "../../../../hooks/useSellModeFilters";
import primaryComponents from "../../../primaryComponents";
import styles from "./styles.module.scss";
import externalStyles from "../MobileMenu/styles.module.scss";

export const MobileProductFilter = ({
  pricingType,
  defaultView,
  setDefaultView = () => {},
  setPricingType = () => {},
}) => {
  const { data: pricingTypes, isLoading: isLoadingPricingTypes } =
    useGetPricingTypes();
  const { search, filterByInventoryType } = useSellModeFilters();

  return (
    <section className={styles.mobileProductFilter}>
      <div className="ml-auto d-flex" style={{ gap: "3px" }}>
        <button
          className={`${externalStyles.button} ${externalStyles.long} ${defaultView === "grid" ? styles.active : ""}`}
          onClick={() => setDefaultView("grid")}
        >
          <GridIcon color={defaultView === "grid" ? "#7647EE" : undefined} />
          <span>Grid View</span>
        </button>
        <button
          className={`${externalStyles.button} ${externalStyles.long} ${defaultView === "list" ? styles.active : ""}`}
          onClick={() => setDefaultView("list")}
        >
          <ListIcon color={defaultView === "list" ? "#7647EE" : undefined} />
          <span>List View</span>
        </button>
      </div>

      <primaryComponents.SelectField
        label={"Product Type"}
        options={["All", "Products", "Services"]}
        value={
          search.get("type") === "goods"
            ? "Products"
            : search.get("type") === "services"
              ? "Services"
              : "All"
        }
        onChange={(value) => {
          filterByInventoryType(value);
        }}
        floatError={false}
      />
      <hr />

      {!isLoadingPricingTypes ? (
        <primaryComponents.SelectField
          label={"Pricing Type"}
          options={pricingTypes}
          nameKey="label"
          idKey="id"
          isSearchable={false}
          value={
            pricingTypes?.find((pricingItem) => pricingItem?.id === pricingType)
              ?.label
          }
          onChange={(val) => setPricingType(val)}
          floatError={false}
        />
      ) : null}
    </section>
  );
};
